import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NoAccessPage: React.FC = () => {
    const navigate = useNavigate();

    const handleBackHome = () => {
        navigate('/login');
    };

    return (
        <Result
            status="403"
            title="403"
            subTitle="Sorry, you do not have access to this application."
            extra={
                <Button type="primary" onClick={handleBackHome}>
                    Back Home
                </Button>
            }
        />
    );
};

export default NoAccessPage;
